




















import { Component, Prop, Vue } from 'vue-property-decorator';

import { SnsEndpoint } from '@/types/core-push';

@Component
export default class SnsEndpointView extends Vue {
  
  @Prop({ default: () => {},  type: Object}) snsEndpoint!: SnsEndpoint;


}
